export const marketplaceAddress = "0x62Df7BB95D2480caA481D7D36D08407A4EB82b61"


// 207e0c12.0ca654f5c03a4be18a3185ea63c31f81   API FOR UPLOAD TO LIGHTHOUSE